<iframe
        [src]="href() | safe"
        title="Handbuch"
        style="flex: 1; border: unset">
</iframe>

